import { Show, Typography } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { IPartner } from "interfaces/partner";
import { FC } from "react";
import { formatPhone } from "utils/formaters";

export const PartnerShow: FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IPartner>();
  return (
    <Show title="Detalhes do Parceiro" isLoading={queryResult.isLoading} headerButtons={[]}>
      <Typography.Title level={5}>Nome</Typography.Title>
      <Typography.Text>{queryResult.data?.data.partner_name}</Typography.Text>

      <Typography.Title level={5}>Código do Parceiro</Typography.Title>
      <Typography.Text>{queryResult.data?.data.partner_code}</Typography.Text>

      <Typography.Title level={5}>Telefone</Typography.Title>
      <Typography.Text>{formatPhone(queryResult.data?.data.partner_phone)}</Typography.Text>
    </Show>
  );
};
